/* eslint-disable no-nested-ternary */
import {
  Button,
  Heading,
  Pagination,
  Paragraph,
  TabBar,
} from '@tmov/design-system';
import { WaveVariantB } from '@tmov/design-system/icons';
import { notification } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import truckCircle from '../../../assets/images/truck-circle.png';
import { LoadingContainer } from '../../../components/LoadingContainer';
import NoDataContainer from '../../../components/NoDataContainer';
import apiShipper from '../../../services/apiShipper';
import StatusCotacaoEnum from '../Enum/StatusCotacaoEnum';
import { Cotacao } from './Cotacao';
import FiltersDrawer from './FiltersDrawer';
import {
  Container,
  CotacaoGrid,
  Header,
  HeaderLeft,
  HeaderRight,
  PaginationContainer,
} from './styles';

const initialFilters = {
  produto: null,
  origem: null,
  destino: null,
};

export default function Cotacoes() {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [drawerActive, setDrawerActive] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(1);

  const [cotacoes, setCotacoes] = useState([]);
  const [idStatus, setIdStatus] = useState(StatusCotacaoEnum.EM_ANDAMENTO);
  const [statusCounts, setStatusCounts] = useState({
    [StatusCotacaoEnum.EM_ANDAMENTO]: 0,
    [StatusCotacaoEnum.AGENDADO]: 0,
    [StatusCotacaoEnum.ENCERRADO]: 0,
  });
  const currentCotacoes = useMemo(
    () =>
      loading ? (
        <LoadingContainer>
          <WaveVariantB size="60px" />
        </LoadingContainer>
      ) : cotacoes?.length > 0 ? (
        <CotacaoGrid>
          {cotacoes.map(cotacao => (
            <Cotacao
              onClick={() =>
                history.push({ pathname: `/cotacao/${cotacao.id}` })
              }
              data-testid={cotacao.id}
              key={cotacao.id}
              cotacao={cotacao}
              status={idStatus}
            />
          ))}
        </CotacaoGrid>
      ) : (
        <NoDataContainer
          img={truckCircle}
          title="Suas cotações aparecerão aqui"
          description="Crie uma oferta e descubra as melhores preços para o seu frete."
        />
      ),
    [cotacoes, idStatus, loading]
  );
  const tabsCotacoes = useMemo(
    () =>
      [
        StatusCotacaoEnum.EM_ANDAMENTO,
        StatusCotacaoEnum.AGENDADO,
        StatusCotacaoEnum.ENCERRADO,
      ].map(status => ({
        id: status,
        title: StatusCotacaoEnum.getTipo(status).label,
        ...(statusCounts[status] >= 0 && {
          count: statusCounts[status],
        }),
        content: currentCotacoes,
      })),
    [currentCotacoes, statusCounts]
  );

  const handleGoToNewCotacaoPage = () => {
    history.push({ pathname: '/cotacao/criar' });
  };

  const handleChangeTab = tab => {
    setIdStatus(tab);
    setCurrentPage(1);
  };

  useEffect(() => {
    const loadCotacoes = async () => {
      setLoading(true);
      try {
        const { produto, origem, destino } = filters;
        const { data } = await apiShipper.get(
          'cotacoes/consultar-todos-paginado',
          {
            params: {
              idStatus,
              page: currentPage,
              size: 8,
              ...(produto && { idProduto: produto.id }),
              ...(origem && { idOrigem: origem.id }),
              ...(destino && { idDestino: destino.id }),
            },
          }
        );
        setCotacoes(data.content);
        setNumPages(data.totalPages);
        setStatusCounts({
          [StatusCotacaoEnum.EM_ANDAMENTO]: data.totalEmAndamento,
          [StatusCotacaoEnum.AGENDADO]: data.totalAgendado,
          [StatusCotacaoEnum.ENCERRADO]: data.totalEncerrado,
        });
      } catch {
        notification.error({
          message:
            'Erro inesperado ao listar Cotações. Recarregue a página e tente novamente',
          description:
            'Caso o problema persista, entre em contato com nosso suporte.',
        });
        setCotacoes([]);
        setNumPages(0);
      }
      setLoading(false);
    };
    loadCotacoes();
  }, [currentPage, filters, idStatus]);

  return (
    <>
      <Container>
        <Header>
          <HeaderLeft>
            <Heading variant="h2">Cotações</Heading>
            <Paragraph>Crie cotações e negocie ofertas de frete</Paragraph>
          </HeaderLeft>
          <HeaderRight>
            <Button
              variant="outlined"
              onClick={() => setDrawerActive(prev => !prev)}
            >
              Filtrar
            </Button>
            <Button onClick={handleGoToNewCotacaoPage}>Criar cotação</Button>
          </HeaderRight>
        </Header>
        <TabBar
          selectedTabId={idStatus}
          tabs={tabsCotacoes}
          onChange={handleChangeTab}
        />
      </Container>
      <PaginationContainer>
        <Pagination
          currentPage={currentPage}
          onChange={page => setCurrentPage(page)}
          numPages={numPages}
          disabled={loading}
        />
      </PaginationContainer>
      <FiltersDrawer
        drawerActive={drawerActive}
        setDrawerActive={setDrawerActive}
        filters={filters}
        updateFilters={setFilters}
      />
    </>
  );
}
